import { render } from "./RatingValue.vue?vue&type=template&id=418b471d"
import script from "./RatingValue.vue?vue&type=script&lang=js"
export * from "./RatingValue.vue?vue&type=script&lang=js"

import "./RatingValue.vue?vue&type=style&index=0&id=418b471d&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__